import React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';

import Item from './Item';

const renderGoals = (goalsGroupedByUsers) => {
  const result = [];

  _.forEach(goalsGroupedByUsers, (goals, userId) => {
    result.push(<Item key={userId} userId={userId} goals={goals} />);
  });

  return result;
};

const List = ({ goalsGroupedByUsers, title, titlePrefix, titleSuffix, t }) => {
  return (
    <React.Fragment>
      {title && (
        <h3>
          <span className="u-color-fountain-blue">
            {t('home.goalsTitlePrefix')}
          </span>
          {t('home.goalsTitle')}
          <span className="u-color-fountain-blue">
            {t('home.goalsTitleSuffix')}
          </span>
        </h3>
      )}
      <div className="c-box c-box-primary">
        {renderGoals(goalsGroupedByUsers)}
      </div>
    </React.Fragment>
  );
};

export default translate()(List);



// WEBPACK FOOTER //
// ./src/events/goals/List.js